import { render, staticRenderFns } from "./LoginReminder.vue?vue&type=template&id=912a774a&scoped=true&"
import script from "./LoginReminder.vue?vue&type=script&lang=js&"
export * from "./LoginReminder.vue?vue&type=script&lang=js&"
import style0 from "./LoginReminder.vue?vue&type=style&index=0&id=912a774a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912a774a",
  null
  
)

export default component.exports